import { z } from 'zod';
import { mitigationDryingIdSchema, mitigationDryingReadingSchema, mitigationDryingWorkspaceSchema, } from './mitigation-drying-workspace.contract.js';
import { mitigationDailyMonitoringSessionSchema, mitigationMoldClearanceRecordSchema, mitigationTreatmentRecordSchema, } from './mitigation-field-completion.contract.js';
export const mitigationDryingReportDataCapability = 'mitigation.drying-report-data.v1';
export const mitigationDryingReportDataQuerySchema = z.strictObject({
    includeVoided: z.boolean().default(false),
});
const readingSnapshotSchema = z.strictObject({
    readingId: mitigationDryingIdSchema,
    workDate: z.string().date(),
    valueMillis: z.number().int(),
    unit: z.enum(['percent', 'relative', 'grains-per-pound', 'fahrenheit']),
    occurredAt: z.string().datetime({ offset: true }),
});
export const mitigationDryingReportPointProgressSchema = z.strictObject({
    pointId: mitigationDryingIdSchema,
    label: z.string().trim().min(1).max(160),
    dryGoalMillis: z.number().int().min(0).max(999_000).nullable(),
    readingCount: z.number().int().nonnegative(),
    initialReading: readingSnapshotSchema.nullable(),
    latestReading: readingSnapshotSchema.nullable(),
    reachedDryGoal: z.boolean().nullable(),
});
export const mitigationDryingReportRoomProgressSchema = z.strictObject({
    roomId: mitigationDryingIdSchema,
    name: z.string().trim().min(1).max(160),
    materialType: z.enum(['drywall', 'hardwood', 'concrete', 'carpet', 'plywood', 'other']),
    dryGoalMillis: z.number().int().min(0).max(999_000).nullable(),
    monitoringPoints: z.array(mitigationDryingReportPointProgressSchema),
    reachedDryGoal: z.boolean().nullable(),
});
const boundedProjectionSchema = (schema) => z.strictObject({
    data: z.array(schema),
    total: z.number().int().nonnegative(),
    truncated: z.boolean(),
});
export const mitigationDryingReportDataSchema = z.strictObject({
    contractVersion: z.literal(mitigationDryingReportDataCapability),
    projectId: mitigationDryingIdSchema,
    producedAt: z.string().datetime({ offset: true }),
    workspace: mitigationDryingWorkspaceSchema,
    roomProgress: z.array(mitigationDryingReportRoomProgressSchema),
    readings: boundedProjectionSchema(mitigationDryingReadingSchema),
    dailyMonitoring: boundedProjectionSchema(mitigationDailyMonitoringSessionSchema),
    treatments: boundedProjectionSchema(mitigationTreatmentRecordSchema),
    moldClearances: boundedProjectionSchema(mitigationMoldClearanceRecordSchema),
    composition: z.strictObject({
        includesOnlyMitigationOwnedData: z.literal(true),
        projectDataCapability: z.literal('projects.project-detail.v1'),
        relationshipDataCapability: z.literal('relationships.project-participants.v1'),
        assetPlacementCapability: z.literal('assets.placements.v1'),
        documentRenderingCapability: z.literal('documents.rendering.v1'),
    }),
});
export const mitigationDryingReportDataResponseSchema = z.strictObject({
    data: mitigationDryingReportDataSchema,
});
//# sourceMappingURL=mitigation-drying-report-data.contract.js.map